export const inquiriesRequests = (requestor: any) => ({
  /**
   * @name getInquiries
   * @description Function used to make request to get all inquiries
   */

    getInquiries: async () => {
        const url = `/inquiries/getInquires`;
        const response = await requestor({
        method: 'GET',
        url,
        });
    
        return response;
    }
});